import type { NavImpactSurfaces } from '../AutotestNavImpactStats';

export const spec = (): Partial<NavImpactSurfaces> => ({
  statStyle: 'delta_chip',
  statLayout: 'stacked',
});
